var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fd-placeholder-module",style:(_vm.style)},[_c('i',{class:_vm.meta.icon}),_vm._v(" "),_c('div',{staticClass:"info"},[_vm._v(_vm._s(_vm.$_('fd.placeholdermodule.info')))])])}
var staticRenderFns = []

export { render, staticRenderFns }